import React from "react";
import "./hero.css";
import "./shapeDevider.css";

interface HeroSectionProps {
  backgroundImage: string;
  title: string;
  subtitle: string;
  dividerPath: string;
  dividerColour: string;
}

const HeroSection: React.FC<HeroSectionProps> = ({ backgroundImage, title, subtitle, dividerPath, dividerColour }) => {
  return (
    <div
      className="HeroSection"
      style={{ backgroundImage: `url(${backgroundImage})`, backgroundPosition: "top" }}
    >
      <div className="HeroText">
        <h2>{title}</h2>
        <h1>{subtitle}</h1>
      </div>

      <div className="Divider">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 320"
          preserveAspectRatio="none"
        >
          <path fill={dividerColour} fillOpacity="1" d={dividerPath}></path>
        </svg>
      </div>
    </div>
  );
};

export default HeroSection;
